import { PawPrint, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 11: "Społeczność kochająca zwierzęta" - emocjonalny, budujący wspólnotę
 */
export const InstagramStoryShare11 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "#4E8A6E", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "200px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Main headline */}
        {/* Main headline */}
        <h1
          style={{
            fontSize: "72px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 32px",
            textAlign: "center",
            lineHeight: 1.25,
          }}
        >
          Zbudujmy społeczność,
          <br />
          która kocha
          <br />
          zwierzęta 🐾💚
        </h1>

        {/* Divider */}
        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", margin: "16px 0 40px" }} />

        {/* Subtitle */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 16px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Udostępnienie to też realna pomoc
        </p>

        {/* Highlighted "3 osobom" card */}
        <div
          style={{
            background: "rgba(255,255,255,0.95)",
            borderRadius: "28px",
            padding: "32px 52px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            marginBottom: "16px",
            border: "3px solid #4E8A6E",
          }}
        >
          <p
            style={{
              fontSize: "46px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Prześlij to <span style={{ color: "#4E8A6E" }}>3 osobom</span>,
            <br />
            które kochają zwierzaki
          </p>
        </div>

        <p
          style={{
            fontSize: "40px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Im nas więcej, tym więcej realnej pomocy
        </p>

        {/* Visual - 3 circles */}
        <div
          style={{
            display: "flex",
            gap: "24px",
            marginBottom: "40px",
          }}
        >
          {["🧑", "👩", "🧑‍🦱"].map((emoji, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.95)",
                borderRadius: "50%",
                width: "130px",
                height: "130px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
                fontSize: "56px",
              }}
            >
              {emoji}
            </div>
          ))}
        </div>

        <p
          style={{
            fontSize: "36px",
            fontWeight: 700,
            color: "#3D6B52",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.4,
          }}
        >
          3 osoby × ich 3 osoby = więcej dobra 💚
        </p>

      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
